<template>
    <div>
        <button
          type="button"
          class="btn btn-primary btn-with-addon mr-auto text-nowrap d-none d-md-block"
          @click="openModal()"
        >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-plus-circle" />
          </span>
          Nieuwe Afdeling
        </button>
        <department-modal :fetchOrganizations="()=>{this.fetchOrganizations()}" ref="addDepartmentModal"/>

    </div>
</template>

<script>
import DepartmentModal from './DepartmentModal.vue'
export default {
  props: ['fetchOrganizations', 'organizationId'],
  components: {
    DepartmentModal,
  },
  data() {
    return {
      addDepartmentVisible: false,
      emptyDepartmentInformation: {
        name: undefined,
        zipcode: undefined,
        streetname_housenumber: undefined,
        coc_number: undefined,
        country: 'Nederland',
        city: undefined,
        invoice_email: undefined,
      },
      departmentInformation: undefined,
    }
  },
  methods: {
    openModal(departmentInformation = undefined) {
      this.$refs.addDepartmentModal.openModal(this.organizationId, departmentInformation)
    },
  },
}
</script>
